<template>
  <PurchaseHeader>
    <DisbursementTable/>
  </PurchaseHeader>
</template>

<script>
import PurchaseHeader from "@/purchase/components/PurchaseHeader.vue";
import DisbursementTable from "@/purchase/components/tables/DisbursementTable.vue";

export default {
  name: 'DisbursementView',
  components: {PurchaseHeader, DisbursementTable}
}
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

h1
  color THEME_COLOR_PRIMARY

  span
    color THEME_COLOR_PRIMARY_FADDED
</style>
